<template>
  <!-- 走进武夷山 -->
  <div :key="domKey">
    <div style="position:relative">
      <TopButtom v-bind:buttonlist="buttonlist" v-on:changeDataList="changeDataList"></TopButtom>
    </div>
    <div class="tabcpage" v-show="ifShowList">
      <div class="rowA" v-show="deviceId == 1">
        <div class="english">PROGRAME</div>
        <div class="chinese">演出节目</div>
      </div>
      <div class="rowB">
        <div class="body">
          <div class="line"></div>
          <div v-for="item in datalist" :key="item.key">
            <div style="display:flex;flex-direction:row" @click="seeInfo(item)">
              <div class="middleDiv">
                <img :src="item.icon" class="middleImg" v-if="item.icon != null" />
                <img src="@/assets/image/wys.png" class="middleImg" v-else />
              </div>
              <div style="display:flex;flex-direction:column">
                <div class="topTitle">{{ item.title }}</div>
                <div class="desc">{{ item.introduce }}</div>
              </div>
            </div>
            <div class="line" style="margin-top:1.3888vh"></div>
          </div>
          <div class="footer">
            <NewPagunation :total="total" :nowCurrent="current" :pageSize="pageSize" @getPage="getPage"></NewPagunation>
          </div>
        </div>
      </div>
      <div class="rowC">
        <div class="layout">
          <div style="writing-mode:vertical-rl;display:flex;flex-direction:row">
            <div style="margin-top:1.018vh;">武夷山景区</div>
            <div style="margin-top:1.018vh;">天下难寻</div>
            <div style="margin-top:1.018vh;">Wuyi</div>
            <div>Mountain</div>
          </div>
        </div>
      </div>
    </div>
    <DetailsInfo :info="info" @closed="closed" v-show="!ifShowList"></DetailsInfo>
  </div>
</template>
<script>
import "@/css/switch.css"
import NewPagunation from "@/components/common/NewPagunation.vue";
import TopButtom from "@/components/common/TopButtom.vue";
import { getMenuOpenList } from "@/api/publicApi";
import { addHits } from "@/util/publicHits";
import DetailsInfo from "./detailsInfo";
export default {
  name: "EnterTab",
  components: { TopButtom, NewPagunation, DetailsInfo },
  data() {
    return {
      ifShowList: true,//是否显示列表
      info: {},
      domKey: '',
      current: 1,
      pageSize: 3,
      total: 0,
      datalist: [],
      buttonlist: [
        {
          id: 1,
          leftS: "left:1.5625vw",
          leftX: "left:1.458vw",
          title: "演出节目",
          noCheckX: false
        },
      ]
    };
  },
  watch: {
    deviceId: {
      handler(deviceId) {
        this.current = 1;
        let timestamp = Date.parse(new Date())
        this.domKey = timestamp
        this.buttonlist.forEach(element => {
          element.id == deviceId ? (element.noCheckX = false) : (element.noCheckX = true);
        });
        if (deviceId == 1) {
          this.getEntertainmentShowFunction();
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    deviceId() {
      return this.$store.state.tabPage;
    }
  },
  methods: {
    //切换标签
    changeDataList(type) {
      this.$store.commit("setTabPage", type);
      let name = "EnterTab";
      this.$emit("specialtyListFunction", name);
    },
    //详情
    seeInfo(info) {
      if (info.status) {
        if (info.status === 1) {
          //增加点击量
          addHits(info.id);
          this.info = info;
          this.ifShowList = false;
        } else {
          window.open(info.brief)
        }
      } else {
        //增加点击量
        addHits(info.id);
        this.info = info;
        this.ifShowList = false;
      }
    },
    //演出
    async getEntertainmentShowFunction() {
      const { code, data } = await getMenuOpenList(0, 'entertainment_show', this.current, this.pageSize);
      if (code == 200) {
        this.datalist = data.records;
        let BASE_URL = this.Global;
        this.datalist.forEach(element => {
          element.introduce != null
            ? (element.introduce = element.introduce.slice(0, 176) + ".....")
            : "";
          element.icon != null
            ? (element.icon = `${BASE_URL}${element.icon}`)
            : "";
          element.url != null
            ? (element.url = `${BASE_URL}${element.url}`)
            : "";
        });
        this.total = data.total;
      }
    },
    //分页
    getPage(current) {
      this.current = current;
      let deviceId = this.deviceId;
      if (deviceId == 1) {
        this.getEntertainmentShowFunction();
      }
    },
    //返回
    closed() {
      let deviceId = this.deviceId;
      if (deviceId == 1) {
        this.getEntertainmentShowFunction();
      }
      this.ifShowList = true;
    },
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/entertainment/enterTab.vue